import { render, staticRenderFns } from "./SnomedBrowserLicence.vue?vue&type=template&id=2908e8f3&scoped=true"
import script from "./SnomedBrowserLicence.vue?vue&type=script&lang=js"
export * from "./SnomedBrowserLicence.vue?vue&type=script&lang=js"
import style0 from "./SnomedBrowserLicence.vue?vue&type=style&index=0&id=2908e8f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2908e8f3",
  null
  
)

export default component.exports